const getStyles = () => {
  return {
    section: {
      padding: '80px 0',
      '@media (max-width: 768px)': {
        padding: '60px 0'
      }
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px'
    },
    title: {
      fontWeight: '700',
      fontSize: '48px',
      lineHeight: '1.2',
      textAlign: 'center',
      marginBottom: '16px',
      color: '#000000',
      '@media (max-width: 768px)': {
        fontSize: '36px'
      }
    },
    subtitle: {
      fontSize: '20px',
      textAlign: 'center',
      marginBottom: '64px',
      color: 'rgba(0,0,0,0.7)'
    },
    benefitsGrid: {
      display: 'grid',
      gap: '24px',
      '@media (min-width: 768px)': {
        gridTemplateColumns: 'repeat(2, 1fr)'
      },
      '@media (min-width: 1024px)': {
        gridTemplateColumns: 'repeat(4, 1fr)'
      }
    },
    benefitCard: {
      textAlign: 'center',
      transition: 'all 0.3s ease-in-out',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      '&:hover': {
        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
        transform: 'translateY(-4px)'
      }
    },
    cardContent: {
      padding: '24px'
    },
    iconContainer: {
      width: '56px',
      height: '56px',
      backgroundColor: 'rgba(150, 180, 220, 0.1)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 16px auto',
      transition: 'all 0.3s ease-in-out'
    },
    benefitIcon: {
      width: '28px',
      height: '28px',
      color: '#4f46e5',
      transition: 'all 0.3s ease-in-out'
    },
    benefitText: {
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '1.4',
      color: '#000000'
    }
  };
};

export default getStyles;
